<mat-expansion-panel class="expansion-panel" [expanded]="step === 1" (opened)="setStep(1)">

  <mat-expansion-panel-header class="custom-header">
    <mat-panel-title>
      2. Ficha do Protocolo
    </mat-panel-title>
  </mat-expansion-panel-header>

  <mat-progress-bar *ngIf="loadCNPJs" class="progress-bar" mode="indeterminate"></mat-progress-bar>
  <form [formGroup]="cabecalhoAdiantamento">
    <div class="container container-input" fxLayout="row" fxLayout.xs="column" fxLayoutGap="0.5%">
      <mat-form-field>
        <input matInput formControlName="frmCnpjEmpresa" [(ngModel)]="cabecalhoProtocolo.cnpjEmpresa" (change)="carregarEmpresaTomador()" placeholder="CNPJ DA EMPRESA MRV" required [textMask]="{mask: mask.cnpj}">
        <mat-error *ngIf="f.frmCnpjEmpresa.errors && f.frmCnpjEmpresa.errors.required">{{getErrorCNPJMessage()}}</mat-error>
      </mat-form-field>
      <mat-form-field>
        <input matInput formControlName="frmNomeEmpresa" [(ngModel)]="cabecalhoProtocolo.nomeEmpresa" value="{{empresaMRV.descricaoEmp}}" placeholder="NOME DA EMPRESA MRV">
        <mat-error *ngIf="f.frmNomeEmpresa.errors && f.frmNomeEmpresa.errors.required">Nome da empresa deve ser preenchido
        </mat-error>
      </mat-form-field>
      <mat-form-field class="example-full-width">
        <input formControlName="frmAprovador" type="text" placeholder="APROVADOR" aria-label="Number" matInput [formControl]="frmAprovador" [(ngModel)]="cabecalhoProtocolo.aprovador" [(value)]="cabecalhoProtocolo.aprovador" [matAutocomplete]="autoAprovador" required>
        <mat-autocomplete #autoAprovador="matAutocomplete">
          <mat-option *ngFor="let option of filteredOptionsAprovador | async" [value]="option">
            {{option}}
          </mat-option>
        </mat-autocomplete>
        <mat-error *ngIf="f.frmAprovador.errors && f.frmAprovador.errors.required">Um aprovador válido deve ser selecionado</mat-error>
        <mat-hint *ngIf="carregandoAprovador">Carregando aprovadores, aguarde finalizar <img alt="Imagem load" src="assets/images/load32.gif" /></mat-hint>
      </mat-form-field>
    </div>
    <div class="container container-input" fxLayout="row" fxLayout.xs="column" fxLayoutGap="0.5%">
      <mat-form-field>
        <input matInput formControlName="frmCnpjFornecedor" [(ngModel)]="cabecalhoProtocolo.cnpjFornecedor" (change)="carregarFornecedor()" placeholder="CNPJ/CPF/CÓDIGO DO FORNECEDOR" maxlength="20" required>
        <mat-error *ngIf="f.frmCnpjFornecedor.errors && f.frmCnpjFornecedor.errors.required">{{getErrorCNPJMessage()}}</mat-error>
      </mat-form-field>

      <mat-form-field>
        <input matInput formControlName="frmNomeFornecedor" placeholder="NOME FORNECEDOR" [(ngModel)]="cabecalhoProtocolo.nomeFornecedor" value="{{fornecedor.nomeFornecedor}}">
        <mat-error *ngIf="f.frmNomeFornecedor.errors && f.frmNomeFornecedor.errors.required">Nome do fornecedor deve ser preenchido</mat-error>
      </mat-form-field>
      <mat-form-field class="example-full-width">
        <input formControlName="frmDivisao" type="text" placeholder="DIVISÃO" aria-label="Number" matInput [formControl]="frmDivisao" [(ngModel)]="cabecalhoProtocolo.divisao" [(value)]="cabecalhoProtocolo.divisao" [matAutocomplete]="autoDivisao" required>
        <mat-autocomplete #autoDivisao="matAutocomplete">
          <mat-option *ngFor="let option of filteredOptionsDivisao | async" [value]="option">
            {{option}}
          </mat-option>
        </mat-autocomplete>
        <mat-error *ngIf="f.frmDivisao.errors && f.frmDivisao.errors.required">Uma divisão válida deve ser selecionada</mat-error>
        <mat-hint *ngIf="carregandoDivisao">Carregando divisão, aguarde finalizar <img alt="Imagem load" src="assets/images/load32.gif" /></mat-hint>
      </mat-form-field>
    </div>
    <div class="container container-input" fxLayout="row" fxLayout.xs="column" fxLayoutGap="0.5%">
      <mat-form-field fxFlex="33%">
        <input *ngIf="modoEdicao" matInput formControlName="frmDescTipoDespesa" placeholder="TIPO DE DESPESAS" [(ngModel)]="descTipoDespesa" value="{{descTipoDespesa}}">
        <mat-select *ngIf="!modoEdicao" formControlName="frmTipoDespesa" placeholder="TIPO DE DESPESAS" [(ngModel)]="tiposDespesaSelected.codDespesa" required>
          <mat-option *ngFor="let tpDespesa of tipoDespesas" [value]="tpDespesa">
            {{tpDespesa.codDespesa}} - {{tpDespesa.tipoDespesa}}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="f.frmTipoDespesa.errors && f.frmTipoDespesa.errors.required">Um tipo de despesa deve ser selecionado</mat-error>
      </mat-form-field>
    </div>
    <mat-action-row class="footer">
      <button mat-button color="warn" (click)="prevStepProtocolo()">Voltar</button>
      <button mat-button color="primary" class="btn-primary" (keyup.enter)="onSubmitCabecalho()" (click)="onSubmitCabecalho()">CONTINUAR</button>
    </mat-action-row>
  </form>
</mat-expansion-panel>

<mat-expansion-panel class="expansion-panel margin20" [expanded]="step === 2" (opened)="setStep(2)">
  <mat-expansion-panel-header class="custom-header">

    <mat-panel-title>
      3. Itens de adiantamento
    </mat-panel-title>
  </mat-expansion-panel-header>
  <form [formGroup]="itensAdiantamentoForm">
    <div class="container container-input" fxLayout="row" fxLayout.xs="column" fxLayoutGap="0.5%">
      <mat-form-field fxFlex="25%">
        <input matInput formControlName="frmValorDespesa" [(ngModel)]="rateioDespesas.valor" placeholder="Valor" class="example-right-align" currencyMask [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }">
        <mat-error *ngIf="fItens.frmValorDespesa.errors && fItens.frmValorDespesa.errors.required">É necessario um valor</mat-error>
      </mat-form-field>
      <mat-form-field fxFlex="75%">
        <input matInput formControlName="frmDescricaoDespesa" [(ngModel)]="rateioDespesas.descricao" placeholder="Descrição">
        <mat-error *ngIf="fItens.frmDescricaoDespesa.errors && fItens.frmDescricaoDespesa.errors.required">A descrição é obrigatório</mat-error>
      </mat-form-field>
    </div>

    <mat-action-row class="footer">
      <button mat-stroked-button *ngIf="modoEdicao" color="warn" class="cancel-button" (click)="CancelarProtocolo()">CANCELAR PROTOCOLO</button>

      <button mat-button color="warn" (click)="prevStep()">Voltar</button>
      <button mat-button color="primary" *ngIf="!modoEdicao" class="btn-primary extra-large" (click)="Salvar()">SALVAR PROTOCOLO</button>
    </mat-action-row>
  </form>
</mat-expansion-panel>